
import React from 'react';
import { Separator } from '@/components/ui/separator';
import DomainItem from './DomainItem';

interface Domain {
  id: string;
  domain: string;
  status: 'pending' | 'verified' | 'active';
  created_at: string;
}

interface DomainsListProps {
  domains: Domain[];
  getStatusBadge: (status: string) => React.ReactNode;
  verifyDomain: (domainId: string, domain: string) => Promise<void>;
  verifyDomainManually: (domainId: string) => Promise<void>;
  deleteDomain: (domainId: string) => Promise<void>;
  isVerifying: string | null;
  isDeleting: string | null;
  verificationError: string | null;
  dnsCheckResult: any;
  manualVerification: boolean;
}

export const DomainsList: React.FC<DomainsListProps> = ({
  domains,
  getStatusBadge,
  verifyDomain,
  verifyDomainManually,
  deleteDomain,
  isVerifying,
  isDeleting,
  verificationError,
  dnsCheckResult,
  manualVerification,
}) => {
  if (domains.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        Aucun domaine personnalisé configuré
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {domains.map((domain) => (
        <DomainItem
          key={domain.id}
          domain={domain}
          getStatusBadge={getStatusBadge}
          verifyDomain={verifyDomain}
          verifyDomainManually={verifyDomainManually}
          deleteDomain={deleteDomain}
          isVerifying={isVerifying}
          isDeleting={isDeleting}
          verificationError={verificationError}
          dnsCheckResult={dnsCheckResult}
          manualVerification={manualVerification}
        />
      ))}
    </div>
  );
};

export default DomainsList;
